import { Component, OnInit, NgZone, ChangeDetectionStrategy } from "@angular/core";
import {
    UntypedFormGroup,
    UntypedFormBuilder,
    Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { ToastService } from "../../services/toast.service";
import { first } from "rxjs/operators";
import { LoaderService } from "../../services/loader.service";
import { AccountService } from "src/app/services/account.service";
import { SecurityProfileEnum } from "../../enums/securityProfile.enum";
import { RoutePaths } from "src/app/shared/constants/routePaths.constants";

@Component({
  standalone: false,
    selector: "app-forgot-password",
    templateUrl: "./forgot-password.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        "./forgot-password.component.scss",
        "../login/login.component.scss",
    ],
})
export class ForgotPasswordComponent implements OnInit {
    form: UntypedFormGroup;
    userType: SecurityProfileEnum;

    constructor(
        private _fb: UntypedFormBuilder,
        private authService: AuthService,
        private toastService: ToastService,
        private router: Router,
        private zone: NgZone,
        private loaderSer: LoaderService,
        private accountService: AccountService,
    ) {
        let rememberMe = this.authService.getRememberMe();
        const currentUser = this.authService.getCurrentUser();

        if (this.authService.isLoggedIn() && currentUser && rememberMe) {
            if (this.superAdmin) {
                this.navigateToOldDashboard();
            } else {
                this.navigateToHome();
            }
        } else {
            this.revokeTokens();
        }
    }

    ngOnInit(): void {
        const email = (this.router.getCurrentNavigation()?.extras?.state ?? history.state)?.email ?? '';
        this.form = this._fb.group({
            username: [email, [Validators.required, Validators.email]],
        });
    }

    submit() {
        if (this.form.invalid) {
            this.toastService.displayErrorMessage(
                "Please provide valid username",
                true,
            );
            return;
        }
        this.loaderSer.show();
        this.accountService
            .forgotPassword(this.form.controls.username.value)
            .pipe(first())
            .subscribe(
                (response) => {
                    this.loaderSer.hide();
                    this.toastService.showSuccess(
                        "Please check your email to change your password",
                        true,
                    );
                    this.zone.run(() => {
                        this.router.navigate([RoutePaths.login]);
                    });
                },
                (error) => {
                    this.loaderSer.hide();
                    this.toastService.showError(error);
                },
            );
    }

    get superAdmin() {
        const currentUser = this.authService.getCurrentUser();
        this.userType = currentUser.userType;
        return this.userType === SecurityProfileEnum.SuperAdmin;
    }

    navigateToHome() {
        this.zone.run(() => {
            const landingPage = this.authService.getLandingPageUrl();
            this.router.navigate([landingPage]);
        });
    }

    navigateToOldDashboard() {
        this.zone.run(() => {
            const landingPage = this.authService.getLandingPageUrl();
            this.router.navigate([landingPage]);
        });
    }

    revokeTokens() {
        if (this.authService.isLoggedIn()) {
            this.authService.revokeTokens().subscribe((_) => _);
        }
    }

    backToLogin() {
        this.router.navigate([RoutePaths.login]);
    }
}
